import { Column } from "@antv/g2plot";
import { Badge } from "antd";
import join from "lodash/join";
import get from "lodash/get";
import map from "lodash/map";

const getlabel = (graphId) => {
  switch (graphId) {
    case 1:
      return {
        style: { fill: "#555555", fontWeight: "600", fontSize: 12 },
        position: "middle",
        rotate: -Math.PI * 0,
      };
    case 2:
    case 3:
    case 4:
    case 5:
      return {
        style: { fill: "#555555", fontWeight: "600", fontSize: 12 },
        position: "top",
        rotate: -Math.PI * 0,
      };
  }
};

///#555555

const getYlabelStyle = (graphId) => {
  switch (graphId) {
    case 1:
      return { fill: "black" };
    case 2:
    case 3:
    case 4:
    case 5:
      return { fill: "black" };
  }
};

const getXlabelStyle = (graphId) => {
  switch (graphId) {
    case 1:
      return { fill: "black" };
    case 2:
    case 3:
    case 4:
    case 5:
      return { fill: "black" };
  }
};

const TestDscription = () => {
  return (
    <div class="bg-gray-50 rounded-lg shadow-md p-4 text-sm text-gray-700 w-64">
      <div class="font-semibold text-gray-600 text-base mb-3 border-b pb-1">
        ${title}
      </div>
      <div class="grid grid-cols-2 gap-y-2 gap-x-4">hello</div>
    </div>
  );
};

const cncGetGraphConfig = (graphId, type, meta = {}) => {
  switch (graphId) {
    case 1:
      return new Column(`graph-${graphId}`, {
        data: [],
        isStack: true,
        legend: false,
        autoFit: true,
        xField: "xAxisLabel",
        yField: "value",
        seriesField: "type",
        padding: "auto",
        renderer: "canvas",
        color: ["#558b2f", "#ff6e40", "#9e9e9e"],
        label: {
          ...getlabel(graphId),
          layout: [
            { type: "interval-adjust-position" },
            { type: "interval-hide-overlap" },
          ],
          formatter: (dataum) => {
            return get(dataum, "value") ? get(dataum, "value") : 0;
          },
        },
        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          type: "cat",
          tickCount: 31,
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: get(datum, "type"),
              value: `${get(datum, "value")} ${
                type === "time" ? "Min" : "Hours"
              }`,
            };
          },
        },
      });
    case 2:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        color: ["#2196F3", "#29B6F6", "#AB47BC", "#9e9e9e"],
        appendPadding: [20, 0, 0, 0],
        isStack: true,
        legend: false,
        autoFit: true,
        stackField: "type",
        seriesField: "type",
        padding: "auto",
        renderer: "canvas",
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return {
              name: "Count",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0}`,
            };
          },
        },

        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        meta: {
          value: {
            alias: "time",
          },
        },
      });
    case 3:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        color: "#4caf50",
        appendPadding: [20, 0, 0, 0],
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return {
              name: "Machining time",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0}`,
            };
          },
        },

        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        meta: {
          value: {
            alias: "time",
          },
        },
      });
    case 4:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        color: "#ffa000",
        appendPadding: [20, 0, 0, 0],
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return {
              name: "Non-Machining time",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0}`,
            };
          },
        },

        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        meta: {
          value: {
            alias: "time",
          },
        },
      });
    case 5:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        color: "#455a64",
        appendPadding: [20, 0, 0, 0],
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return {
              name: "Power consumed",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0} Kwh`,
            };
          },
        },

        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        meta: {
          value: {
            alias: "Kwh",
          },
        },
      });
  }
};

export default cncGetGraphConfig;
